import { Icon, Label, mergeStyles } from "@fluentui/react";
import { useState } from "react";

type Props = {
  index: number;
  uuid: string;
};

export default ({ index, uuid }: Props) => {
  const [isHovering, setHovering] = useState(false);

  return (
    <div
      className={divStyles}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      {isHovering ? (
        <Icon
          iconName="Move"
          className={iconStyles}
          id={`rowMoveIcon-${uuid}`}
        />
      ) : (
        <Label>{index}</Label>
      )}
    </div>
  );
};

const divStyles = mergeStyles({
  width: "1.5rem",
  height: "1.5rem",
  cursor: "grab",
});
const iconStyles = mergeStyles({
  fontSize: "1.25rem",
  marginTop: "0.5rem",
});
